import React from 'react';
import { CreditCard, Shield, Banknote, FileText, Linkedin, Facebook, Instagram, Twitter } from "lucide-react";


const FooterComponent = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 py-10 px-4 sm:px-6 lg:px-10 relative overflow-hidden">
      {/* Background gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 opacity-50"></div>
      
      <div className="max-w-7xl mx-auto relative z-10">
        {/* Header section with logo and social icons */}
        {/* <div className="flex flex-col lg:flex-row justify-between items-center border-b border-gray-700 pb-8">
          <div className="text-center lg:text-left mb-8 lg:mb-0">
            <h1 className="text-2xl lg:text-3xl font-bold text-white bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
              TheFinmaster
            </h1>
            <p className="text-sm text-gray-400 mt-2">Empowering your finance journey</p>
          </div>
          <div className="flex flex-wrap justify-center gap-4 py-4">
          <a 
            href="/credit-card"
            className="group relative px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-500 hover:to-blue-600 text-white font-medium rounded-full transition-all duration-300 transform hover:scale-105 hover:shadow-xl shadow-blue-500/25 border border-blue-400/30 backdrop-blur-sm min-w-fit"
          >
            <div className="flex items-center space-x-2">
              <Calculator size={16} />
              <span className="relative z-10 whitespace-nowrap">Credit Card</span>
            </div>
            <div className="absolute inset-0 bg-gradient-to-r from-blue-400 to-blue-500 rounded-full opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
            <div className="absolute inset-0 rounded-full bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </a>
          
          <a 
            href="/insurance"
            className="group relative px-6 py-3 bg-gradient-to-r from-green-600 to-green-700 hover:from-green-500 hover:to-green-600 text-white font-medium rounded-full transition-all duration-300 transform hover:scale-105 hover:shadow-xl shadow-green-500/25 border border-green-400/30 backdrop-blur-sm min-w-fit"
          >
            <div className="flex items-center space-x-2">
              <BookOpen size={16} />
              <span className="relative z-10 whitespace-nowrap">Insurance </span>
            </div>
            <div className="absolute inset-0 bg-gradient-to-r from-green-400 to-green-500 rounded-full opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
            <div className="absolute inset-0 rounded-full bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </a>
          
          <a 
            href="/loan"
            className="group relative px-6 py-3 bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-500 hover:to-purple-600 text-white font-medium rounded-full transition-all duration-300 transform hover:scale-105 hover:shadow-xl shadow-purple-500/25 border border-purple-400/30 backdrop-blur-sm min-w-fit"
          >
            <div className="flex items-center space-x-2">
              <Users size={16} />
              <span className="relative z-10 whitespace-nowrap">Get Loan</span>
            </div>
            <div className="absolute inset-0 bg-gradient-to-r from-purple-400 to-purple-500 rounded-full opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
            <div className="absolute inset-0 rounded-full bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </a>
          
          <a 
            href="/demat"
            className="group relative px-6 py-3 bg-gradient-to-r from-orange-600 to-orange-700 hover:from-orange-500 hover:to-orange-600 text-white font-medium rounded-full transition-all duration-300 transform hover:scale-105 hover:shadow-xl shadow-orange-500/25 border border-orange-400/30 backdrop-blur-sm min-w-fit"
          >
            <div className="flex items-center space-x-2">
              <span className="relative z-10 whitespace-nowrap">Demat</span>
            </div>
            <div className="absolute inset-0 bg-gradient-to-r from-orange-400 to-orange-500 rounded-full opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
            <div className="absolute inset-0 rounded-full bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </a>
        </div>
          
          <div className="flex space-x-6 mb-4 lg:mb-0">
            <a 
              href="https://www.linkedin.com/company/thefinmaster/posts/?feedView=all" 
              target="_blank"
              rel="noopener noreferrer" 
              className="group relative p-3 bg-gray-800 rounded-full hover:bg-blue-600 transition-all duration-300 transform hover:scale-110 hover:shadow-lg hover:shadow-blue-500/25"
              aria-label="LinkedIn"
            >
              <Linkedin size={20} className="group-hover:text-white transition-colors duration-300" />
            </a>
            <a 
              href="#" 
              className="group relative p-3 bg-gray-800 rounded-full hover:bg-blue-700 transition-all duration-300 transform hover:scale-110 hover:shadow-lg hover:shadow-blue-500/25"
              aria-label="Facebook"
            >
              <Facebook size={20} className="group-hover:text-white transition-colors duration-300" />
            </a>
            <a 
              href="#" 
              className="group relative p-3 bg-gray-800 rounded-full hover:bg-pink-600 transition-all duration-300 transform hover:scale-110 hover:shadow-lg hover:shadow-pink-500/25"
              aria-label="Instagram"
            >
              <Instagram size={20} className="group-hover:text-white transition-colors duration-300" />
            </a>
            <a 
              href="#" 
              className="group relative p-3 bg-gray-800 rounded-full hover:bg-sky-500 transition-all duration-300 transform hover:scale-110 hover:shadow-lg hover:shadow-sky-500/25"
              aria-label="Twitter"
            >
              <Twitter size={20} className="group-hover:text-white transition-colors duration-300" />
            </a>
          </div>
        </div> */}
  <div className="flex flex-col lg:flex-row justify-between items-center border-b border-gray-700 pb-8 px-4">
  {/* Logo and Tagline */}
  <div className="text-center lg:text-left mb-8 lg:mb-0">
    <p className="text-2xl lg:text-3xl font-bold text-white bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
      TheFinmaster
    </p>
    <p className="text-sm text-gray-400 mt-2">Empowering your finance journey</p>
  </div>

  {/* Action Buttons */}
  <div className="flex flex-wrap justify-center gap-4 py-4">
    <a href="/credit-card" className="group relative px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-500 hover:to-blue-600 text-white font-medium rounded-full transition-all duration-300 transform hover:scale-105 hover:shadow-xl shadow-blue-500/25 border border-blue-400/30 backdrop-blur-sm min-w-fit">
      <div className="flex items-center space-x-2">
        <CreditCard size={16} />
        <p className="relative z-10 whitespace-nowrap">Credit Card</p>
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-blue-400 to-blue-500 rounded-full opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
      <div className="absolute inset-0 rounded-full bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
    </a>

    <a href="/insurance" className="group relative px-6 py-3 bg-gradient-to-r from-green-600 to-green-700 hover:from-green-500 hover:to-green-600 text-white font-medium rounded-full transition-all duration-300 transform hover:scale-105 hover:shadow-xl shadow-green-500/25 border border-green-400/30 backdrop-blur-sm min-w-fit">
      <div className="flex items-center space-x-2">
        <Shield size={16} />
        <p className="relative z-10 whitespace-nowrap">Insurance</p>
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-green-400 to-green-500 rounded-full opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
      <div className="absolute inset-0 rounded-full bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
    </a>

    <a href="/loan" className="group relative px-6 py-3 bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-500 hover:to-purple-600 text-white font-medium rounded-full transition-all duration-300 transform hover:scale-105 hover:shadow-xl shadow-purple-500/25 border border-purple-400/30 backdrop-blur-sm min-w-fit">
      <div className="flex items-center space-x-2">
        < Banknote size={16} />
        <p className="relative z-10 whitespace-nowrap">Get Loan</p>
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-purple-400 to-purple-500 rounded-full opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
      <div className="absolute inset-0 rounded-full bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
    </a>

    <a href="/demat" className="group relative px-6 py-3 bg-gradient-to-r from-orange-600 to-orange-700 hover:from-orange-500 hover:to-orange-600 text-white font-medium rounded-full transition-all duration-300 transform hover:scale-105 hover:shadow-xl shadow-orange-500/25 border border-orange-400/30 backdrop-blur-sm min-w-fit">
      <div className="flex items-center space-x-2">
        <FileText size={16} />
        <p className="relative z-10 whitespace-nowrap">Demat</p>
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-orange-400 to-orange-500 rounded-full opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
      <div className="absolute inset-0 rounded-full bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
    </a>
  </div>

  {/* Social Media Icons */}
  <div className="flex space-x-4 mt-6 lg:mt-0">
    <a href="https://www.linkedin.com/company/thefinmaster/posts/?feedView=all" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="group relative p-3 bg-gray-800 rounded-full hover:bg-blue-600 transition-all duration-300 transform hover:scale-110 hover:shadow-lg hover:shadow-blue-500/25">
      <Linkedin size={20} className="group-hover:text-white transition-colors duration-300" />
    </a>
    {/* <a href="#" aria-label="Facebook" className="group relative p-3 bg-gray-800 rounded-full hover:bg-blue-700 transition-all duration-300 transform hover:scale-110 hover:shadow-lg hover:shadow-blue-500/25">
      <Facebook size={20} className="group-hover:text-white transition-colors duration-300" />
    </a>
    <a href="#" aria-label="Instagram" className="group relative p-3 bg-gray-800 rounded-full hover:bg-pink-600 transition-all duration-300 transform hover:scale-110 hover:shadow-lg hover:shadow-pink-500/25">
      <Instagram size={20} className="group-hover:text-white transition-colors duration-300" />
    </a>
    <a href="#" aria-label="Twitter" className="group relative p-3 bg-gray-800 rounded-full hover:bg-sky-500 transition-all duration-300 transform hover:scale-110 hover:shadow-lg hover:shadow-sky-500/25">
      <Twitter size={20} className="group-hover:text-white transition-colors duration-300" />
    </a> */}
  </div>
</div>

        {/* Links section - 4 columns */}
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 text-sm">
          <div className="group">
            <h3 className="text-white font-semibold mb-4 text-lg relative">
              Legal
              <div className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-blue-400 to-purple-400 group-hover:w-full transition-all duration-300"></div>
            </h3>
            <ul className="space-y-3">
              <li>
                <a href="/privacy-policy" className="hover:text-white transition-all duration-300 hover:pl-2 relative ">
                  Privacy Policy
                  <span className="absolute left-0 top-1/2 w-0 h-0.5 bg-blue-400 transform -translate-y-1/2 group-hover/link:w-4 transition-all duration-300"></span>
                </a>
              </li>
              <li>
                <a href="/term-and-conditions" className="hover:text-white transition-all duration-300 hover:pl-2 relative ">
                  Terms & Conditions
                  <span className="absolute left-0 top-1/2 w-0 h-0.5 bg-blue-400 transform -translate-y-1/2 group-hover/link:w-4 transition-all duration-300"></span>
                </a>
              </li>
            </ul>
          </div>
          
          <div className="group">
            <h3 className="text-white font-semibold mb-4 text-lg relative">
              Support
              <div className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-green-400 to-blue-400 group-hover:w-full transition-all duration-300"></div>
            </h3>
            <ul className="space-y-3">
              <li>
                <a 
                  href="https://www.linkedin.com/company/thefinmaster/posts/?feedView=all" 
                  target="_blank"
                  rel="noopener noreferrer" 
                  className="hover:text-white transition-all duration-300 hover:pl-2 relative"
                >
                  LinkedIn
                  <span className="absolute left-0 top-1/2 w-0 h-0.5 bg-green-400 transform -translate-y-1/2 group-hover/link:w-4 transition-all duration-300"></span>
                </a>
              </li>
              <li>
                <a href="/contact-us" className="hover:text-white transition-all duration-300 hover:pl-2 relative ">
                  Contact
                  <span className="absolute left-0 top-1/2 w-0 h-0.5 bg-green-400 transform -translate-y-1/2 group-hover/link:w-4 transition-all duration-300"></span>
                </a>
              </li>
            </ul>
          </div>
          
          <div className="group">
            <h3 className="text-white font-semibold mb-4 text-lg relative">
              Company
              <div className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-purple-400 to-pink-400 group-hover:w-full transition-all duration-300"></div>
            </h3>
            <ul className="space-y-3">
              <li>
                <a href="/about" className="hover:text-white transition-all duration-300 hover:pl-2 relative ">
                  About
                  <span className="absolute left-0 top-1/2 w-0 h-0.5 bg-purple-400 transform -translate-y-1/2 group-hover/link:w-4 transition-all duration-300"></span>
                </a>
              </li>
              <li>
                <a href="/blog" className="hover:text-white transition-all duration-300 hover:pl-2 relative ">
                  Blog
                  <span className="absolute left-0 top-1/2 w-0 h-0.5 bg-purple-400 transform -translate-y-1/2 group-hover/link:w-4 transition-all duration-300"></span>
                </a>
              </li>
              <li>
                <a href="/sitemap" className="hover:text-white transition-all duration-300 hover:pl-2 relative ">
                  Sitemap
                  <span className="absolute left-0 top-1/2 w-0 h-0.5 bg-purple-400 transform -translate-y-1/2 group-hover/link:w-4 transition-all duration-300"></span>
                </a>
              </li>
              <li>
                <a href="/contact-us" className="hover:text-white transition-all duration-300 hover:pl-2 relative ">
                  Contact
                  <span className="absolute left-0 top-1/2 w-0 h-0.5 bg-purple-400 transform -translate-y-1/2 group-hover/link:w-4 transition-all duration-300"></span>
                </a>
              </li>
            </ul>
          </div>
          
          <div className="group">
            <h3 className="text-white font-semibold mb-4 text-lg relative">
              Financial Tools
              <div className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-orange-400 to-red-400 group-hover:w-full transition-all duration-300"></div>
            </h3>
            <ul className="space-y-3">
              <li>
                <a href="/financial-tools-calculators/emi-calculator" className="hover:text-white transition-all duration-300 hover:pl-2 relative ">
                  EMI Calculator
                  <span className="absolute left-0 top-1/2 w-0 h-0.5 bg-orange-400 transform -translate-y-1/2 group-hover/link:w-4 transition-all duration-300"></span>
                </a>
              </li>
              <li>
                <a href="/financial-tools-calculators/mutual-fund-calculator" className="hover:text-white transition-all duration-300 hover:pl-2 relative ">
                  Mutual Fund Calculator
                  <span className="absolute left-0 top-1/2 w-0 h-0.5 bg-orange-400 transform -translate-y-1/2 group-hover/link:w-4 transition-all duration-300"></span>
                </a>
              </li>
              <li>
                <a href="/financial-tools-calculators/home-loan-emi-calculator" className="hover:text-white transition-all duration-300 hover:pl-2 relative ">
                  Home Loan EMI Calculator
                  <span className="absolute left-0 top-1/2 w-0 h-0.5 bg-orange-400 transform -translate-y-1/2 group-hover/link:w-4 transition-all duration-300"></span>
                </a>
              </li>
              <li>
                <a href="/financial-tools-calculators/car-loan-emi-calculator" className="hover:text-white transition-all duration-300 hover:pl-2 relative">
                  Car Loan EMI Calculator
                  <span className="absolute left-0 top-1/2 w-0 h-0.5 bg-orange-400 transform -translate-y-1/2 group-hover/link:w-4 transition-all duration-300"></span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright section */}
        <div className="text-center text-xs text-gray-500 mt-12 pt-8 border-t border-gray-700 relative">
          <div className="flex justify-center items-center">
            <span className="bg-gradient-to-r from-gray-400 to-gray-500 bg-clip-text text-transparent">
              © 2025 TheFinmaster. All rights reserved.
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterComponent;
// 'use client';

// import {
//   BsFacebook,
//   BsInstagram,
//   BsTwitter,
//   BsLinkedin,
// } from 'react-icons/bs';

// const FooterComponent = () => {
//   return (
//     <footer className="bg-gray-900 text-gray-300 py-10 px-10">
//       <div className="max-w-7xl mx-auto">
//         {/* Header section with logo and social icons */}
//         <div className="flex flex-col md:flex-row justify-between items-center border-b border-gray-700 pb-6">
//           <div className="text-center md:text-left mb-6 md:mb-0">
//             <h1 className="text-2xl font-bold text-white">TheFinmaster</h1>
//             <p className="text-sm text-gray-400 mt-1">Empowering your finance journey</p>
//           </div>
//           <div className="text-center md:text-left mb-6 md:mb-0">
//             <h1 className="text-2xl font-bold text-white">TheFinmaster</h1>
//             <p className="text-sm text-gray-400 mt-1">Empowering your finance journey</p>
//           </div>
//           <div className="text-center md:text-left mb-6 md:mb-0">
//             <h1 className="text-2xl font-bold text-white">TheFinmaster</h1>
//             <p className="text-sm text-gray-400 mt-1">Empowering your finance journey</p>
//           </div>
//           <div className="flex space-x-6">
//             <a 
//               href="https://www.linkedin.com/company/thefinmaster/posts/?feedView=all" 
//               target="_blank"
//               rel="noopener noreferrer" 
//               className="hover:text-white transition-all duration-300 transform hover:scale-110"
//               aria-label="LinkedIn"
//             >
//               <BsLinkedin size={20} />
//             </a>
//             <a 
//               href="#" 
//               className="hover:text-white transition-all duration-300 transform hover:scale-110"
//               aria-label="Facebook"
//             >
//               <BsFacebook size={20} />
//             </a>
//             <a 
//               href="#" 
//               className="hover:text-white transition-all duration-300 transform hover:scale-110"
//               aria-label="Instagram"
//             >
//               <BsInstagram size={20} />
//             </a>
//             <a 
//               href="#" 
//               className="hover:text-white transition-all duration-300 transform hover:scale-110"
//               aria-label="Twitter"
//             >
//               <BsTwitter size={20} />
//             </a>
//           </div>
//         </div>

//         {/* Links section - 4 columns */}
//         <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-8 text-sm">
//           <div>
//             <h3 className="text-white font-semibold mb-4">Legal</h3>
//             <ul className="space-y-2">
//               <li><a href="/privacy-policy" className="hover:text-white transition-colors duration-300 hover:pl-1">Privacy Policy</a></li>
//               <li><a href="/term-and-conditions" className="hover:text-white transition-colors duration-300 hover:pl-1">Terms & Conditions</a></li>
//             </ul>
//           </div>
//           <div>
//             <h3 className="text-white font-semibold mb-4">Support</h3>
//             <ul className="space-y-2">
//               <li>
//                 <a 
//                   href="https://www.linkedin.com/company/thefinmaster/posts/?feedView=all" 
//                   target="_blank"
//                   rel="noopener noreferrer" 
//                   className="hover:text-white transition-colors duration-300 hover:pl-1"
//                 >
//                   LinkedIn
//                 </a>
//               </li>
//               <li><a href="/contact-us" className="hover:text-white transition-colors duration-300 hover:pl-1">Contact</a></li>
//             </ul>
//           </div>
//           <div>
//             <h3 className="text-white font-semibold mb-4">Company</h3>
//             <ul className="space-y-2">
//               <li><a href="/about" className="hover:text-white transition-colors duration-300 hover:pl-1">About</a></li>
//               <li><a href="/blog" className="hover:text-white transition-colors duration-300 hover:pl-1">Blog</a></li>
//               <li><a href="/sitemap" className="hover:text-white transition-colors duration-300 hover:pl-1">Sitemap</a></li>
//               <li><a href="/contact-us" className="hover:text-white transition-colors duration-300 hover:pl-1">Contact</a></li>
//             </ul>
//           </div>
//           <div>
//             <h3 className="text-white font-semibold mb-4">Tools</h3>
//             <ul className="space-y-2">
//               <li><a href="/financial-tools-calculators/emi-calculator" className="hover:text-white transition-colors duration-300 hover:pl-1">EMI Calculator</a></li>
//               <li><a href="/financial-tools-calculators/mutual-fund-calculator" className="hover:text-white transition-colors duration-300 hover:pl-1">Mutual Fund Calculator</a></li>
//               <li><a href="/financial-tools-calculators/home-loan-emi-calculator" className="hover:text-white transition-colors duration-300 hover:pl-1">Home Loan EMI Calculator</a></li>
//               <li><a href="/financial-tools-calculators/car-loan-emi-calculator" className="hover:text-white transition-colors duration-300 hover:pl-1">Car Loan EMI Calculator</a></li>
//             </ul>
//           </div>
//         </div>

//         {/* Copyright section */}
//         <div className="text-center text-xs text-gray-500 mt-10 relative">
//           <div className="flex justify-center items-center">
//             <span>© 2024 TheFinmaster. All rights reserved.</span>
//           </div>
         
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default FooterComponent;

// 'use client';

// import {
//   BsFacebook,
//   BsInstagram,
//   BsTwitter,
//   BsGithub,
//   BsDribbble,
//   BsLinkedin,
// } from 'react-icons/bs';

// const FooterComponent = () => {
//   return (
//     <footer className="bg-gray-900 text-gray-300 py-10 px-6">
//       <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center border-b border-gray-700 pb-6">
//         <div className="text-center md:text-left mb-6 md:mb-0">
//           <h1 className="text-2xl font-bold text-white">TheFinmaster</h1>
//           <p className="text-sm text-gray-400 mt-1">Empowering your finance journey</p>
//         </div>
//         <div className="flex space-x-6">
//         <a href="https://www.linkedin.com/company/thefinmaster/posts/?feedView=all"   target="_blank"
//   rel="noopener noreferrer" className="hover:text-white transition">
//   <BsLinkedin size={20} />
// </a>
//           <a href="#" className="hover:text-white transition">
//             <BsFacebook size={20} />
//           </a>
//           <a href="#" className="hover:text-white transition">
//             <BsInstagram size={20} />
//           </a>
//           <a href="#" className="hover:text-white transition">
//             <BsTwitter size={20} />
//           </a>
    
//           {/* <a href="#" className="hover:text-white transition">
//             <BsDribbble size={20} />
//           </a> */}
//         </div>
//       </div>

//       <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-8 text-sm text-center md:text-left">
//         <div>
//         <h3 className="text-white font-semibold mb-2">Legal</h3>
//           <ul className="space-y-1">
//             <li><a href="/privacy-policy" className="hover:underline">Privacy Policy</a></li>
//             {/* <li><a href="#" className="hover:underline">Licensing</a></li> */}
//             <li><a href="/term-and-conditions" className="hover:underline">Terms & Conditions</a></li>
//           </ul>
//         </div>
//         <div>
//           <h3 className="text-white font-semibold mb-2">Support</h3>
//           <ul className="space-y-1">
//             <li><a href="https://www.linkedin.com/company/thefinmaster/posts/?feedView=all"   target="_blank"
//   rel="noopener noreferrer" className="hover:underline">LinkedIn</a></li>
//             {/* <li><a href="#" className="hover:underline">Help Center</a></li>
//             <li><a href="#" className="hover:underline">Partners</a></li> */}
//             <li><a href="/contact-us" className="hover:underline">Contact</a></li>
//           </ul>
//         </div>
//         <div>


//           <h3 className="text-white font-semibold mb-2">Company</h3>
//           <ul className="space-y-1">
//             <li><a href="/about" className="hover:underline">About</a></li>
//             <li><a href="/blog" className="hover:underline">Blog</a></li>
//             <li><a href="/sitemap" className="hover:underline">Sitemap</a></li>
//             <li><a href="/contact-us" className="hover:underline">Contact</a></li>
//           </ul>
//         </div>
//         <div>
//           <h3 className="text-white font-semibold mb-2">Tools</h3>
//           <ul className="space-y-1">
//             <li><a href="/financial-tools-calculators/emi-calculator" className="hover:underline">EMI Calculator</a></li>
//             <li><a href="/financial-tools-calculators/mutual-fund-calculator" className="hover:underline">Mutual Fund Calculator</a></li>
//             <li><a href="/financial-tools-calculators/home-loan-emi-calculator" className="hover:underline">Home Loan EMI Calculator</a></li>
//             <li><a href="/financial-tools-calculators/car-loan-emi-calculator" className="hover:underline">Car Loan EMI Calculator </a></li>
//           </ul>
//         </div>
//       </div>

//       <div className="text-center text-xs text-gray-500 mt-10">
//         © 2024 TheFinmaster. All rights reserved.
//       </div>
//     </footer>
//   );
// };

// export default FooterComponent;


// 'use client';

// import { Footer } from 'flowbite-react';
// import { useEffect } from 'react';

// import { BsDribbble, BsFacebook, BsGithub, BsInstagram, BsTwitter } from 'react-icons/bs';


// // Define the FooterComponent
// const FooterComponent = () => {
    
 
//     return (
//         <Footer bgDark>
//             <div className="w-full">
//                 <div className="grid w-[95%] grid-cols-2 gap-8 mx-auto py-8 md:grid-cols-4">
//                     <div>
//                         <Footer.Title title="Company" />
//                         <Footer.LinkGroup col>
//                             <Footer.Link href="/about">
//                                 About
//                             </Footer.Link>
//                             <Footer.Link href="/blog_page">
//                                 Blog
//                             </Footer.Link>
//                             <Footer.Link href="/sitemap">
//                                 SiteMap
//                             </Footer.Link>
                            
//                             <Footer.Link href="/contact-us" >
//                                 Contact Us
//                             </Footer.Link>
//                         </Footer.LinkGroup>
//                     </div>
//                     <div>
//                         <Footer.Title title="help center" />
//                         <Footer.LinkGroup col>
//                             <Footer.Link href="#">
//                                 Linkedin
//                             </Footer.Link>
//                             <Footer.Link href="#">
//                                 Twitter
//                             </Footer.Link>
//                             <Footer.Link href="#">
//                                 Facebook
//                             </Footer.Link>
//                             <Footer.Link href="/contact-us">
//                                 Contact Us
//                             </Footer.Link>
//                         </Footer.LinkGroup>
//                     </div>
//                     <div>
//                         <Footer.Title title="legal" />
//                         <Footer.LinkGroup col>
//                             <Footer.Link href="/privacy-policy">
//                                 Privacy Policy
//                             </Footer.Link>
//                             <Footer.Link href="#">
//                                 Licensing
//                             </Footer.Link>
//                             <Footer.Link href="/term-and-conditions">
//                                 Terms & Conditions
//                             </Footer.Link>
//                         </Footer.LinkGroup>
//                     </div>
//                     <div>
//                         <Footer.Title title="download" />
//                         <Footer.LinkGroup col>
//                             <Footer.Link href="#">
//                                 iOS
//                             </Footer.Link>
//                             <Footer.Link href="#">
//                                 Android
//                             </Footer.Link>
//                             <Footer.Link href="#">
//                                 Windows
//                             </Footer.Link>
//                             <Footer.Link href="#">
//                                 MacOS
//                             </Footer.Link>
//                         </Footer.LinkGroup>
//                     </div>
//                 </div>

//                 <div className="w-full bg-gray-700 px-4 py-6 sm:flex sm:items-center sm:justify-between">
//                     <Footer.Copyright
//                         by="TheFinmaster. All Rights Reserved"
//                         href="/"
//                         year={2024}
//                     />
//                     <div className="mt-4 flex space-x-6 sm:mt-0 sm:justify-center">
//                         <Footer.Icon
//                             href="#"
//                             icon={BsFacebook}
//                         />
//                         <Footer.Icon
//                             href="#"
//                             icon={BsInstagram}
//                         />
//                         <Footer.Icon
//                             href="#"
//                             icon={BsTwitter}
//                         />
//                         <Footer.Icon
//                             href="#"
//                             icon={BsGithub}
//                         />
//                         <Footer.Icon
//                             href="#"
//                             icon={BsDribbble}
//                         />

//                     </div>
//                 </div>
//             </div>
         
//         </Footer>
//     )
// }

// export default FooterComponent





// 'use client';

// import { Footer } from 'flowbite-react';
// import { useEffect } from 'react';
// // import TagManager from 'react-gtm-module';
// import { BsDribbble, BsFacebook, BsGithub, BsInstagram, BsTwitter } from 'react-icons/bs';

// const FooterComponent = () => {
//     // useEffect(() => {
//     //     // Initialize dataLayer
//     //     window.dataLayer = window.dataLayer || [];
//     //     function gtag(){dataLayer.push(arguments);}
//     //     gtag('js', new Date());
//     //     gtag('config', 'YOUR_GA_TRACKING_ID'); // Replace with your actual Google Analytics Tracking ID
        
//     //     // Example: Sending an event when the footer component mounts
//     //     window.dataLayer.push({
//     //         'event': 'footerLoaded'
//     //     });
//     // }, []);
//     // const handleButtonClick = () => {
//     //     // Example: Push a custom event when a button in the footer is clicked
//     //     TagManager.dataLayer({
//     //       dataLayer: {
//     //         event: 'contactButtonClick'
          
//     //       }
//     //     });
//     //   };
    
//     return (
//         <Footer bgDark>
//             <div className="w-full">
//                 <div className="grid w-[95%] grid-cols-2 gap-8 mx-auto py-8 md:grid-cols-4">
//                     <div>
//                         <Footer.Title title="Company" />
//                         <Footer.LinkGroup col>
//                             <Footer.Link href="/about">
//                                 About
//                             </Footer.Link>
//                             <Footer.Link href="/blog">
//                                 Blog
//                             </Footer.Link>
//                             <Footer.Link href="/about">
//                                 Careers
//                             </Footer.Link>
//                             {/* <Footer.Link href="/contact" onClick={handleButtonClick}>
//                                 Contact Us
//                             </Footer.Link> */}
//                             <Footer.Link href="/contact" >
//                                 Contact Us
//                             </Footer.Link>
//                         </Footer.LinkGroup>
//                     </div>
//                     <div>
//                         <Footer.Title title="help center" />
//                         <Footer.LinkGroup col>
//                             <Footer.Link href="#">
//                                 Linkedin
//                             </Footer.Link>
//                             <Footer.Link href="#">
//                                 Twitter
//                             </Footer.Link>
//                             <Footer.Link href="#">
//                                 Facebook
//                             </Footer.Link>
//                             <Footer.Link href="#">
//                                 Contact Us
//                             </Footer.Link>
//                         </Footer.LinkGroup>
//                     </div>
//                     <div>
//                         <Footer.Title title="legal" />
//                         <Footer.LinkGroup col>
//                             <Footer.Link href="/privacy_policy">
//                                 Privacy Policy
//                             </Footer.Link>
//                             <Footer.Link href="#">
//                                 Licensing
//                             </Footer.Link>
//                             <Footer.Link href="/term_and_conditions">
//                                 Terms & Conditions
//                             </Footer.Link>
//                         </Footer.LinkGroup>
//                     </div>
//                     <div>
//                         <Footer.Title title="download" />
//                         <Footer.LinkGroup col>
//                             <Footer.Link href="#">
//                                 iOS
//                             </Footer.Link>
//                             <Footer.Link href="#">
//                                 Android
//                             </Footer.Link>
//                             <Footer.Link href="#">
//                                 Windows
//                             </Footer.Link>
//                             <Footer.Link href="#">
//                                 MacOS
//                             </Footer.Link>
//                         </Footer.LinkGroup>
//                     </div>
//                 </div>

//                 <div className="w-full bg-gray-700 px-4 py-6 sm:flex sm:items-center sm:justify-between">
//                     <Footer.Copyright
//                         by="FinancialEase Hub"
//                         href="#"
//                         year={2023}
//                     />
//                     <div className="mt-4 flex space-x-6 sm:mt-0 sm:justify-center">
//                         <Footer.Icon
//                             href="#"
//                             icon={BsFacebook}
//                         />
//                         <Footer.Icon
//                             href="#"
//                             icon={BsInstagram}
//                         />
//                         <Footer.Icon
//                             href="#"
//                             icon={BsTwitter}
//                         />
//                         <Footer.Icon
//                             href="#"
//                             icon={BsGithub}
//                         />
//                         <Footer.Icon
//                             href="#"
//                             icon={BsDribbble}
//                         />

//                     </div>
//                 </div>
//             </div>
         
//         </Footer>
//     )
// }

// export default FooterComponent

